import { render, staticRenderFns } from "./AssetManager.vue?vue&type=template&id=53d20d2a&scoped=true"
import script from "./AssetManager.vue?vue&type=script&lang=js"
export * from "./AssetManager.vue?vue&type=script&lang=js"
import style0 from "./AssetManager.vue?vue&type=style&index=0&id=53d20d2a&prod&lang=scss&scoped=true"
import style1 from "./AssetManager.vue?vue&type=style&index=1&id=53d20d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d20d2a",
  null
  
)

export default component.exports